import { Security } from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import { useStateValue } from "../StateProvider";
import "./CartSidebar.css";
function CartSidebar() {
  const [total, setTotal] = useState();
  const [{ cart }] = useStateValue();
  useEffect(() => {
    setTotal(cart.reduce((amount, item) => Number(item.price) + amount, 0));
  });
  return (
    <div className="cartsidebar">
      <div className="cartsiderHeading">
        <p>PRICE DETAILS</p>
      </div>
      <div className="cartsidebar_price">
        <p>Price({cart.length} item) </p>
        <span>₹ {(total*80)+555}</span>
      </div>
      <div className="cartsidebar_discount">
        <p>Discount</p>
        <span>₹ 555</span>
      </div>
      <div className="cartsidebar_delivery">
      <p>Delivery Charges </p>
      <span style={{color:'green',fontSize:'15px'}}>Free</span>

      </div>
      <div className="cartsiderTotal">
        <h5>Total Amount </h5>
        <span>₹{total*80}</span>
      </div>
      <div className="cartsidebar_span">
      <span>You will save ₹555 on this order</span>

      </div>
      <div className="cartsidebar_security">
        <Security/>
        <span>Safe and Secure Payments.Easy returns.100% Authentic products.</span>
      </div>
    </div>
  );
}

export default CartSidebar;
